import { GetRowIdFunc, GetRowIdParams } from 'ag-grid-community'
import { useMemo } from 'react'

export const useGetRowId = () => {
  const getRowId = useMemo<GetRowIdFunc>(() => {
    return (params: GetRowIdParams) => params.data.accountId?.toString()
  }, [])

  return getRowId
}
